import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { useEffect } from 'react';
import { backButton } from '@telegram-apps/sdk-react';

import ProfileController from '@/api/profile/profile.ts';
import {
  buttonShapeStyles,
  buttonStyles,
  containerStyles,
  contentHeaderStyles,
  contentMessageStyles,
  contentShapeStyles,
  contentStyles
} from '@/components/Verification/styles.ts';
import ErrorShape from '@/components/common/svg/shapes/ErrorShape.tsx';
import { helpers } from '@/helpers.ts';
import { useProfileStore } from '@/store/useProfileStore.ts';
import { catchErrors } from '@/utils/sentry-monitor.tsx';

const DeletedProfile = () => {
  const { t } = useTranslation();
  const { aboutMe } = useProfileStore();
  const navigate = useNavigate();

  const handleRecover = async () => {
    try {
      await ProfileController.recoverProfile();
      navigate(helpers.checkRegistrationRoute(aboutMe?.profile));
    } catch (e) {
      catchErrors(e, true);
    }
  };

  useEffect(() => {
    if (backButton.isVisible()) {
      backButton.hide();
    }
  }, []);

  return (
    <div style={containerStyles}>
      <div style={contentStyles}>
        <ErrorShape
          width={70}
          height={70}
          fillColor="#b4b6bc"
          style={contentShapeStyles}
        />
        <span style={contentHeaderStyles}>{t('deleted.page.header')}</span>
        <p style={contentMessageStyles}>{t('deleted.page.message')}</p>
      </div>

      <motion.div
        onClick={handleRecover}
        whileTap={{ scale: 0.9 }}
        style={buttonStyles()}
      >
        <span style={buttonShapeStyles}>{t('deleted.page.button')}</span>
      </motion.div>
    </div>
  );
};

export default DeletedProfile;
